import { AlertOutlined, ApiOutlined, DownloadOutlined, FileExcelOutlined, FileOutlined, FilePdfOutlined, LockFilled, MailOutlined, ShareAltOutlined, UnlockFilled } from '@ant-design/icons';
import { Layout as AntdLayout, Badge } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../store/AuthContext/AuthContext';
import ReportRoutes from '../../../routing/ReportRoutes';
import { useIsAuthorized, useModuleActive } from '../../pages/common/roles/Roles';

const { Sider, Content } = AntdLayout;
const grey = '#bab6b6';
const black = "#051235";

export const ReportsLayout = () => {

	const location = useLocation();
	const pathName = location.pathname;
	const { collapsed, setCollapsed } = useAuth();
	const { t } = useTranslation();			
	const isModuleActive = useModuleActive();


	return (
		<AntdLayout>
			<Sider width={140} className='container-space'  collapsed={collapsed} collapsible={true} trigger={null}>
				<aside>
					<nav>
						{/*<ul>							
							<Link to="/informes/lista">
								<li className={`${(pathName == '/informes/lista') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<FileOutlined style={{color: (pathName == '/informes/lista') ? black : grey }} className='icon-menu-item'/>
										<span className={`${(pathName == '/informes/lista') ? 'selected' : 'no-selected' }`}>Informes</span>
									</div>
								</li>
							</Link> 																			
						</ul>
						<ul>							
							<Link to="/informes/ficheros">
								<li className={`${(pathName == '/informes/ficheros') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<DownloadOutlined style={{color: (pathName == '/informes/ficheros') ? black : grey }} className='icon-menu-item'/>
										<span className={`${(pathName == '/informes/ficheros') ? 'selected' : 'no-selected' }`}>Ficheros</span>
									</div>
								</li>
							</Link> 																			
						</ul>
						<ul>						
							<Link to={isModuleActive('NETWORK') ? "/informes/mail" : "/configurar/plan"}>
								<li className={`${(pathName == '/informes/mail') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<Badge offset={[10, 0]} count={isModuleActive('NETWORK') ? <UnlockFilled style={{ color: 'green' }} /> : <LockFilled style={{ color: 'crimson' }} />}> 										
											<MailOutlined style={{color: (pathName == '/informes/mail') ? black : grey }} className='icon-menu-item'/>										
										</Badge>
										<span className={`${(pathName == '/informes/mail') ? 'selected' : 'no-selected' }`}>Informes</span>
									</div>
								</li>
							</Link>	
						</ul>*/}
						
						<ul>						
							<Link to={"/informes/mail"}>
								<li className={`${(pathName == '/informes/mail') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>										
										<FileOutlined style={{color: (pathName == '/informes/mail') ? black : grey }} className='icon-menu-item'/>
										<span className={`${(pathName == '/informes/mail') ? 'selected' : 'no-selected' }`}>Informes</span>
									</div>
								</li>
							</Link>	
						</ul>
						<ul>						
							<Link to={"/informes/alerts"}>
								<li className={`${(pathName == '/informes/alerts') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>										
										<AlertOutlined style={{color: (pathName == '/informes/alerts') ? black : grey }} className='icon-menu-item'/>																				
										<span className={`${(pathName == '/informes/alerts') ? 'selected' : 'no-selected' }`}>Alertas</span>
									</div>
								</li>
							</Link>	
						</ul>
						<ul>						
							<Link to={"/informes/api"}>	
								<li className={`${(pathName == '/informes/api') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<Badge offset={[10, 0]} count={isModuleActive('API') ? <UnlockFilled style={{ color: 'green' }} /> : <LockFilled style={{ color: 'crimson' }} />}> 
											<ApiOutlined style={{color: (pathName == '/informes/api') ? black : grey }} className='icon-menu-item'/>
										</Badge>
										<span className={`${(pathName == '/informes/api') ? 'selected' : 'no-selected' }`}>API</span>
									</div>
								</li>
							</Link>	
						</ul>						
					</nav>
				</aside>
			</Sider>			
			<Content className='container-space'>
				<div>
					<ReportRoutes />
				</div>
			</Content>			
		</AntdLayout>
	)
};
